import axios from 'axios';
import { API_URL } from 'constantes/constantes';

export default async function getEventosCalendario(fecha, seccion) {
    const BASE_PATH = API_URL;
    let fechaInicial = "2024-01-19"
    let apiURL;

    if (fecha) {
        apiURL = `${BASE_PATH}${seccion}/${encodeURIComponent(fecha)}.json`;
    } else {
        apiURL = `${BASE_PATH}${seccion}/${fechaInicial}.json`;
    }
    // const apiURL = BASE_PATH + `json/widgets/${fecha}.json`;

    const config = {
        method: 'get',
        url: apiURL,
        timeout: 25000,
        withCredentials: false,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        }
    }

    try {
        const response = await axios(config);

        if (response.status === 200) {
            return { data: response.data, statusCode: 200 };
        } else if (response.status === 404) {
            // Recurso no encontrado
            return { statusCode: 404, data: [] };
        } else {
            // Otro código de estado, manejar según sea necesario
            return { statusCode: response.status, data: [] };
        }
    } catch (error) {
        // Manejar errores de la petición
        console.error("Error en la petición:", error);
        return { statusCode: 404, data: [] };
    }
}

// const apiUrl = './data/';
// export default async function getEventosCalendario(fecha) {
//     try {
//       const response = await axios.get(apiUrl + `${fecha}.json`);
//       return response.data;
//     } catch (error) {
//       console.error('Error al cargar el JSON:', error);
//       throw error; 
//     }
//   }



export async function getEventosCalendarioParis(fecha, seccion) {
    const BASE_PATH = API_URL;
    let fechaInicial = "2024-07-24"
    let apiURL;

    if (fecha) {
        apiURL = `${BASE_PATH}${seccion}/${encodeURIComponent(fecha)}.json`;
    } else {
        apiURL = `${BASE_PATH}${seccion}/${fechaInicial}.json`;
    }
    // const apiURL = BASE_PATH + `json/widgets/${fecha}.json`;

    const config = {
        method: 'get',
        url: apiURL,
        timeout: 25000,
        withCredentials: false,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        }
    }

    try {
        const response = await axios(config);

        if (response.status === 200) {
            return { data: response.data, statusCode: 200 };
        } else if (response.status === 404) {
            // Recurso no encontrado
            return { statusCode: 404, data: [] };
        } else {
            // Otro código de estado, manejar según sea necesario
            return { statusCode: response.status, data: [] };
        }
    } catch (error) {
        // Manejar errores de la petición
        console.error("Error en la petición:", error);
        return { statusCode: 404, data: [] };
    }
}


export async function getEventosPorDeporteParis(disciplina, seccion) {
    const BASE_PATH = API_URL;
    let disciplinaInicial = "ATH"
    let apiURL;

    if (disciplina) {
        apiURL = `${BASE_PATH}${seccion}/${encodeURIComponent(disciplina)}.json`;
    } else {
        apiURL = `${BASE_PATH}${seccion}/${disciplinaInicial}.json`;
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: 25000,
        withCredentials: false,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        }
    }

    try {
        const response = await axios(config);

        if (response.status === 200) {
            return { data: response.data, statusCode: 200 };
        } else if (response.status === 404) {
            // Recurso no encontrado
            return { statusCode: 404, data: [] };
        } else {
            // Otro código de estado, manejar según sea necesario
            return { statusCode: response.status, data: [] };
        }
    } catch (error) {
        // Manejar errores de la petición
        console.error("Error en la petición:", error);
        return { statusCode: 404, data: [] };
    }
}


export async function getEventosCalendarioParalimpicos(fecha, seccion) {
    const BASE_PATH = API_URL;
    let fechaInicial = "2024-08-28"
    let apiURL;

    if (fecha) {
        apiURL = `${BASE_PATH}${seccion}/${encodeURIComponent(fecha)}.json`;
    } else {
        apiURL = `${BASE_PATH}${seccion}/${fechaInicial}.json`;
    }
    // const apiURL = BASE_PATH + `json/widgets/${fecha}.json`;

    const config = {
        method: 'get',
        url: apiURL,
        timeout: 25000,
        withCredentials: false,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        }
    }

    try {
        const response = await axios(config);

        if (response.status === 200) {
            return { data: response.data, statusCode: 200 };
        } else if (response.status === 404) {
            // Recurso no encontrado
            return { statusCode: 404, data: [] };
        } else {
            // Otro código de estado, manejar según sea necesario
            return { statusCode: response.status, data: [] };
        }
    } catch (error) {
        // Manejar errores de la petición
        console.error("Error en la petición:", error);
        return { statusCode: 404, data: [] };
    }
}

// const apiUrl = '../data/';
// export async function getEventosCalendarioParis(fecha) {
//     try {
//       const response = await axios.get(apiUrl + `${fecha}.json`);
//       console.log(" response: ", response.data)
//       return { data: response.data, statusCode: 200 };
//     } catch (error) {
//       console.error('Error al cargar el JSON:', error);
//       throw error; 
//     }
//   }